import { createStore, select, withProps } from '@ngneat/elf';
import { Injectable } from '@angular/core';
import { bypassesJoinGate } from '@andor/contracts/permissions';
import { PrivilegesApi, privilegesApiSchema } from '../shared/schemas/backend-api';

const PERMISSIONS_STORE_NAME = 'andorPermissions.v1';

const permissionStore = createStore(
  { name: PERMISSIONS_STORE_NAME },
  // @ts-ignore
  withProps<PrivilegesApi>(privilegesApiSchema.parse({}))
);

@Injectable({
  providedIn: 'root',
})
export class PermissionStore {
  store = permissionStore;
  muteUser$ = permissionStore.pipe(select((state) => state.muteUser));
  pokeUser$ = permissionStore.pipe(select((state) => state.pokeUser));
  grantAccess$ = permissionStore.pipe(select((state) => state.grantAccess));
  closeRoom$ = permissionStore.pipe(select((state) => state.closeRoom));
  editAppSettings$ = permissionStore.pipe(select((state) => state.editAppSettings));
  closeChildRoom$ = permissionStore.pipe(select((state) => state.closeChildRoom));
  openChildRoom$ = permissionStore.pipe(select((state) => state.openChildRoom));
  manageRooms$ = permissionStore.pipe(select((state) => state.manageRooms));
  joinAnyRoom$ = permissionStore.pipe(select((state) => state.joinAnyRoom));
  /** Joins private and off-schedule rooms without knocking (`bypassesJoinGate`). */
  bypassesJoinGate$ = permissionStore.pipe(select((state) => bypassesJoinGate(state)));
  makeRoomPrivate$ = permissionStore.pipe(select((state) => state.makeRoomPrivate));
  kickUser$ = permissionStore.pipe(select((state) => state.kickUser));
  useMicrophone$ = permissionStore.pipe(select((state) => state.useMicrophone));
  useCamera$ = permissionStore.pipe(select((state) => state.useCamera));
  clearDrawings$ = permissionStore.pipe(select((state) => state.clearDrawings));
  clearTextChat$ = permissionStore.pipe(select((state) => state.clearTextChat));
  editAppPermissions$ = permissionStore.pipe(select((state) => state.editAppPermissions));
  startRecording$ = permissionStore.pipe(select((state) => state.startRecording));
  /** Upload files to the room and delete shared files. */
  shareFiles$ = permissionStore.pipe(select((state) => state.shareFiles));
  value$ = permissionStore.pipe(select((state) => state));

  get value() {
    return this.store.value;
  }

  toggleValue<Key extends keyof PrivilegesApi>(key: Key) {
    this.store.update((state) => ({
      ...state,
      [key]: !state[key],
    }));
  }

  update(permissions: Partial<PrivilegesApi>) {
    permissionStore.update((state) => ({
      ...state,
      ...permissions,
    }));
  }
}
